import FJUtil from "../util/FJUtil";
import {FJExportVideoAction, FJModalAction} from "../redux/action/FJRoot.action";
import localforage from "localforage";
import FJCanvasStore from "./FJCanvasStore";
import FJMediaStore from "./FJMediaStore";
import FJCoreUtil from "../core/util/FJCoreUtil";
import FJCoreConstant from "../core/constant/FJCoreConstant";

const PRETREATMENT_TYPES = {
  ADD_RECORD_VIDEO: 'ADD_RECORD_VIDEO',
}

let FJPretreatmentStore = (function () {

  return {
    init: function (store) {
      let inputKey = FJUtil.getQueryString("pretreatment");
      let inputInfo = JSON.parse(window.localStorage.getItem(inputKey));
      if (inputInfo) {
        let initDataFunc = (data) => {

          store.dispatch(FJExportVideoAction.loadProjectForOnlineAction(data));
          // 隐藏加载动画
          store.dispatch(FJModalAction.setIsShowLoadingModalAction(false));
          FJCanvasStore.executeSync(FJCanvasStore.command.INIT_UNDO);
        };
        switch (inputInfo.type) {
          case PRETREATMENT_TYPES.ADD_RECORD_VIDEO: {

            let {files, relativeRect} = inputInfo.data;

            const transData = (data) => {
              const {name} = data;
              if (!name.includes('.webm')) {
                Object.defineProperty(data, "name", {
                  value: `${name}.webm`
                });
              }
              return data;

            };

            // 显示加载动画
            store.dispatch(FJModalAction.setIsShowLoadingModalAction(true));

            // 添加素材
            if (files.length === 1) {
              localforage.getItem(files[0].toString())
                .then(item => {
                  return FJMediaStore.addLocalMediaToLibrary(transData(item.data));
                })
                .then(media => {
                  let graphId = FJCoreUtil.createId();
                  initDataFunc({
                    layer: {
                      mainLayer: [graphId],
                      subLayer: [],
                      subAudioLayer: [],
                    },
                    graphs: [
                      {
                        id: graphId,
                        type: FJCoreConstant.VIDEO,
                        sourceId: media.id,
                        originDuration: media.duration,
                        originSize: media.size,
                        startTime: 0,
                        endTime: media.duration,
                        delay: 0,
                      }
                    ],
                    mediaLibrary: [
                      {
                        duration: media.duration,
                        fromType: "LOCAL",
                        id: media.id,
                        name: media.name,
                        type: media.type,
                      }
                    ],
                  });
                });
            } else if (files.length === 2 && relativeRect) {
              let {relativeRect, cropType, cropRelativeRect} = inputInfo.data;
              (async function () {
                for (let i = 0; i < files.length; i++) {
                  await localforage.getItem(files[i].toString()).then((item) => {
                    return FJMediaStore.addLocalMediaToLibrary(transData(item.data))
                  }).catch((e) => {
                    console.log(e);
                  });
                }
              })().then(() => {
                let mediaOne = FJMediaStore.getMediaById(files[0]);
                let mediaTwo = FJMediaStore.getMediaById(files[1]);
                let graphOneId = FJCoreUtil.createId();
                let graphTwoId = FJCoreUtil.createId();
                let duration = Math.min(mediaOne.duration, mediaTwo.duration);
                let createGraphData = (id, media, options = {}) => {
                  return {
                    id: id,
                    type: FJCoreConstant.VIDEO,
                    sourceId: media.id,
                    originDuration: media.duration,
                    originSize: media.size,
                    startTime: 0,
                    endTime: duration,
                    delay: 0,
                    ...options,
                  }
                };
                let createMediaData = (media) => {
                  return {
                    duration: media.duration,
                    fromType: "LOCAL",
                    id: media.id,
                    name: media.name,
                    type: media.type,
                  }
                };
                initDataFunc({
                  layer: {
                    mainLayer: [graphOneId],
                    subLayer: [graphTwoId],
                    subAudioLayer: [],
                  },
                  graphs: [
                    createGraphData(graphOneId, mediaOne),
                    createGraphData(graphTwoId, mediaTwo, {
                      relativeRect,
                      cropType,
                      cropRelativeRect,
                    }),
                  ],
                  mediaLibrary: [
                    createMediaData(mediaOne),
                    createMediaData(mediaTwo),
                  ],
                });
              }).catch((e) => {
                console.log(e);
              });
            }
            break;
          }
          default:
        }

        window.localStorage.removeItem(inputKey);
      }
    }
  }
})();

export default FJPretreatmentStore;